import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white shadow-sm sm:rounded-lg"
}
const _hoisted_2 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_3 = { class: "sm:flex sm:items-center sm:justify-between" }
const _hoisted_4 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_5 = {
  key: 0,
  class: "rounded-md bg-green-50 p-4 mt-3"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "shrink-0" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm font-medium text-green-800" }
const _hoisted_10 = {
  key: 1,
  class: "rounded-md bg-green-50 p-4 mt-3"
}
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "shrink-0" }
const _hoisted_13 = { class: "ml-3" }
const _hoisted_14 = { class: "text-sm font-medium text-green-800" }
const _hoisted_15 = { class: "ml-auto pl-3" }
const _hoisted_16 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_17 = { class: "sr-only" }
const _hoisted_18 = {
  key: 2,
  class: "rounded-md bg-blue-50 p-4 mt-3"
}
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "shrink-0" }
const _hoisted_21 = { class: "ml-3 flex-1 md:flex md:justify-between" }
const _hoisted_22 = { class: "text-sm text-royal-blue-500" }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { class: "rounded-md bg-gray-50 px-3 py-2.5 sm:flex sm:items-center sm:justify-between" }
const _hoisted_25 = { class: "sm:flex sm:items-center" }
const _hoisted_26 = {
  key: 0,
  class: "h-8 w-auto sm:h-6 sm:shrink-0",
  viewBox: "0 0 36 24",
  "aria-hidden": "true"
}
const _hoisted_27 = {
  key: 1,
  class: "h-8 w-auto sm:h-6 sm:shrink-0",
  viewBox: "0 0 39 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_28 = { class: "mt-3 sm:mt-0 sm:ml-4" }
const _hoisted_29 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_30 = { class: "mt-4 sm:mt-0 sm:ml-6 sm:shrink-0" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 4,
  class: "rounded-md bg-blue-50 p-4 mt-3"
}
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = { class: "shrink-0" }
const _hoisted_35 = { class: "ml-3 flex-1 md:flex md:justify-between" }
const _hoisted_36 = { class: "text-sm text-royal-blue-500" }
const _hoisted_37 = {
  key: 5,
  class: "border-l-4 border-yellow-400 bg-yellow-50 p-4 mt-3"
}
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "shrink-0" }
const _hoisted_40 = { class: "ml-3" }
const _hoisted_41 = { class: "text-sm text-yellow-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon")!
  const _component_ExclamationTriangleIcon = _resolveComponent("ExclamationTriangleIcon")!

  return ((_ctx.wallet.length || !_ctx.isFreeUser) && !_ctx.isLoadingWallet)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('card_list.title')), 1),
            (!_ctx.isFreeUser)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addCard && _ctx.addCard(...args)), ["prevent"])),
                  class: "mt-3 sm:mt-0 inline-flex items-center rounded-md bg-royal-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs cursor-pointer hover:bg-royal-blue-600"
                }, _toDisplayString(_ctx.$t('card_list.add_button')), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCardAdded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_CheckCircleIcon, {
                      class: "size-5 text-green-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('card_list.added_success')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCardDeleted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_CheckCircleIcon, {
                      class: "size-5 text-green-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('card_list.deleted_success')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isCardDeleted = false), ["prevent"])),
                        class: "inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50 focus:outline-hidden"
                      }, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('card_list.dismiss')), 1),
                        _createVNode(_component_XMarkIcon, {
                          class: "size-5",
                          "aria-hidden": "true"
                        })
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.wallet.length === 0 && !_ctx.isLoadingWallet)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_InformationCircleIcon, {
                      class: "size-5 text-royal-blue-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('card_list.no_cards_info')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.wallet.length && !_ctx.isLoadingWallet)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallet, (walletItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mt-3",
                    key: `wallet-item-${index}-${walletItem.key}`
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "sr-only" }, "Visa", -1)),
                      _createElementVNode("div", _hoisted_25, [
                        (walletItem.payment_system === 'visa')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _cache[2] || (_cache[2] = [
                              _createElementVNode("rect", {
                                width: "36",
                                height: "24",
                                fill: "#224DBA",
                                rx: "4"
                              }, null, -1),
                              _createElementVNode("path", {
                                fill: "#fff",
                                d: "M10.925 15.673H8.874l-1.538-6c-.073-.276-.228-.52-.456-.635A6.575 6.575 0 005 8.403v-.231h3.304c.456 0 .798.347.855.75l.798 4.328 2.05-5.078h1.994l-3.076 7.5zm4.216 0h-1.937L14.8 8.172h1.937l-1.595 7.5zm4.101-5.422c.057-.404.399-.635.798-.635a3.54 3.54 0 011.88.346l.342-1.615A4.808 4.808 0 0020.496 8c-1.88 0-3.248 1.039-3.248 2.481 0 1.097.969 1.673 1.653 2.02.74.346 1.025.577.968.923 0 .519-.57.75-1.139.75a4.795 4.795 0 01-1.994-.462l-.342 1.616a5.48 5.48 0 002.108.404c2.108.057 3.418-.981 3.418-2.539 0-1.962-2.678-2.077-2.678-2.942zm9.457 5.422L27.16 8.172h-1.652a.858.858 0 00-.798.577l-2.848 6.924h1.994l.398-1.096h2.45l.228 1.096h1.766zm-2.905-5.482l.57 2.827h-1.596l1.026-2.827z"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (walletItem.payment_system === 'mc')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _cache[3] || (_cache[3] = [
                              _createElementVNode("path", {
                                d: "M38.6082 19.386V18.9218H38.4868L38.3465 19.2406L38.2068 18.9218H38.0847V19.386H38.171V19.0359L38.3022 19.338H38.3915L38.5227 19.0352V19.386H38.6082ZM37.8383 19.386V19.0009H37.9939V18.9225H37.5972V19.0009H37.7528V19.386H37.8383Z",
                                fill: "#F79410"
                              }, null, -1),
                              _createElementVNode("path", {
                                d: "M24.8127 21.3828H14.3124V2.56079H24.8127V21.3828Z",
                                fill: "#FF5F00"
                              }, null, -1),
                              _createElementVNode("path", {
                                d: "M14.9852 11.9703C14.9852 8.15215 16.7775 4.75106 19.5686 2.55927C17.5275 0.95652 14.9516 -0.000104904 12.1521 -0.000104904C5.52451 -0.000104904 0.1521 5.35913 0.1521 11.9703C0.1521 18.5814 5.52451 23.9407 12.1521 23.9407C14.9516 23.9407 17.5275 22.984 19.5686 21.3813C16.7775 19.1895 14.9852 15.7884 14.9852 11.9703Z",
                                fill: "#EB001B"
                              }, null, -1),
                              _createElementVNode("path", {
                                d: "M38.9744 11.9703C38.9744 18.5814 33.602 23.9407 26.9744 23.9407C24.1749 23.9407 21.599 22.984 19.5571 21.3813C22.349 19.1895 24.1413 15.7884 24.1413 11.9703C24.1413 8.15216 22.349 4.75107 19.5571 2.55928C21.599 0.95653 24.1749 -9.53674e-05 26.9744 -9.53674e-05C33.602 -9.53674e-05 38.9744 5.35914 38.9744 11.9703Z",
                                fill: "#F79E1B"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(walletItem.pan), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _withModifiers(($event: any) => (_ctx.removeWalletItem(walletItem)), ["prevent"]),
                          class: "inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50"
                        }, _toDisplayString(_ctx.$t('card_list.delete_button')), 9, _hoisted_31)
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.wallet.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_InformationCircleIcon, {
                      class: "size-5 text-royal-blue-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('card_list.multiple_cards_info')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.wallet.length === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_ExclamationTriangleIcon, {
                      class: "size-5 text-yellow-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t('card_list.delete_last_warning')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}